import type { FaireProductEntity } from "../../entity_types/product";

export const p_d36ghqej22: FaireProductEntity = {
  token: "p_d36ghqej22",
  type: "product",
  name: "Shadow Play",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/ddfc03538b3c7fe48974dea2356afd13e521cad0b07b66f7ed7d85f84dbcc736.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35bef3e1fa21c6b7833cd41e8ec644e4115e421ef0956f92145757b5f86b042c.png",
    "https://cdn.faire.com/fastly/ffb67d19a3ce0e53aa29d0dbbfd82ab42db9cae7df8546ba710913f0ddf86951.png",
    "https://cdn.faire.com/fastly/2398fcfd605f1a89fe10d6c1db99352fef4e05829103bb8dbde86d7805e70c8f.png",
    "https://cdn.faire.com/fastly/f8e4f3d8b4fd6bfef5fdfa5991dfc907c6c244f1ffa16390b9a70c22d663c159.png"
  ],
  priceDollars: 12.77,
  description: "Heavy—Chocolaty—Brown Sugar\n\n𝐁𝐚𝐜𝐤𝐬𝐭𝐨𝐫𝐲:\nShadow Play nods to the slightly more developed roast on this blend without being truly \"dark\". Shadows are a bit of a reverse projection of an object, and this is somewhat true of this blend compared to Tightrope among our two house blends.\n\n𝐎𝐫𝐢𝐠𝐢𝐧𝐬:\nWe've always embraced the role of the roaster and the roast at Highwire. Just as shadows are a dark reflection of an object, Shadow Play is the flipside of our other house blend, Tightrope. It's not fully dark, but it is where a lot of interesting things happen.\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠𝐬:\nPairs well with something moody. We recommend Spiritualized's \"Ladies and Gentlemen We are Floating in Space\", Hawkwind's \"Master of the Universe\", or Sault's \"Wildfires\".\n\n𝐁𝐫𝐞𝐰:\nUse a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.",
  tags: [],
  msrpDollars: 18.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:50.389Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
